import { useEffect } from 'react'
import { observer, inject } from 'mobx-react'
import { Link as RouterLink } from 'react-router'
import styled from '@emotion/styled'
import ProfileCard from '../ProfileCard'
import { legalDocuments } from '../../legal/documents'
import { useDocumentOrigin } from '../../legal/useDocumentOrigin'

function LegalNoticesCard({ store }) {
  const documentOrigin = useDocumentOrigin()

  useEffect(() => {
    const fetchDocuments = async () => {
      store.getDocuments()
    }

    fetchDocuments()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const documents = legalDocuments(store).sort((a, b) => a.label.localeCompare(b.label))

  return (
    <ProfileCard title='Legal notices'>
      <CardContent>
        {documents.map(({ label, href, to }) =>
          to ? (
            <Link key={label} as={RouterLink} to={to} state={documentOrigin}>
              {label}
            </Link>
          ) : (
            <Link key={label} href={href} target='_blank' rel='noreferrer noopener'>
              {label}
            </Link>
          )
        )}
      </CardContent>
    </ProfileCard>
  )
}

export default inject('store')(observer(LegalNoticesCard))

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`

const Link = styled.a`
  display: inline;
  width: auto;
  cursor: pointer;
  color: ${p => p.theme.customLinkColor};
  text-decoration: underline;
`
